var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('b-button', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "height": "max-content"
    },
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.showModal = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell mr-1"
  }), _vm._v(" Setting General Reminder ")]), _c('b-modal', {
    attrs: {
      "title": "General Setting Reminder",
      "hide-footer": "",
      "centered": "",
      "size": "md",
      "body-class": "p-0"
    },
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "p-3"
  }, _vm._l(_vm.forms, function (item, index) {
    return _c('div', {
      key: item.type,
      staticClass: "d-flex align-items-center mb-3"
    }, [_c('b-form-input', {
      staticClass: "mr-3 reminder-type-input",
      attrs: {
        "value": item.type,
        "readonly": ""
      }
    }), _c('b-input-group', {
      staticClass: "reminder-value-input"
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "required": ""
      },
      model: {
        value: _vm.forms[index][_vm.valueField(item)],
        callback: function callback($$v) {
          _vm.$set(_vm.forms[index], _vm.valueField(item), _vm._n($$v));
        },
        expression: "forms[index][valueField(item)]"
      }
    }), _c('b-input-group-append', [_c('b-input-group-text', [_vm._v(_vm._s(_vm.valueSuffix(item)))])], 1)], 1)], 1);
  }), 0), _c('div', {
    staticClass: "d-flex justify-content-end modal-actions border-top p-3"
  }, [_c('b-button', {
    staticClass: "modal-action-btn mr-2",
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Cancel & Close ")]), _c('b-button', {
    staticClass: "modal-action-btn",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.loading
    }
  }, [_vm.loading ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Submit ")], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }